const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤時數', 'Attendance hours', '出勤时数'],
				children: {
					ZZ_KINGSKNOW_AM50035: {
						name: ['排班轉出勤時數', 'Shift shift to attendance hours', '排班转出勤时数'],
						url: '/zz_kingsknow_am50035',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};